export default {
   state: {
      modal: {
         opened: false,
         component: null
      }
   },
   mutations: {
      openModal (state, component) {
         state.modal.opened = true;
         state.modal.component = component;
      },
      closeModal (state) {
         state.modal.opened = false;
         state.modal.component = null;
      }
   },
};